import Link from 'next/link'
import { ArrowLeft } from 'lucide-react'
import { PageHeader } from '@/components/layout/page-header'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Alert, AlertDescription } from '@/components/ui/alert'
import { NewCustomerForm } from '@/app/(dashboard)/customers/_components/NewCustomerForm'
import { apiClient } from '@/lib/api/client'
import { useAsyncData } from '@/src/hooks/useAsyncData'
import { LoadingState } from '@/src/components/LoadingState'
import { ErrorState } from '@/src/components/ErrorState'

export function NewCustomerPage() {
  const { data: profile, error, loading, reload } = useAsyncData(() => apiClient.getProfile(), [])

  if (loading) return <LoadingState label="Checking customer permissions..." />
  if (error) return <ErrorState error={error} onRetry={reload} />

  const canManageCustomers = profile?.is_admin || profile?.role === 'admin'

  return (
    <div className="flex h-full flex-col">
      <PageHeader
        title="Add Customer"
        description="Create a customer account for Helm consignments"
        breadcrumbs={[
          { label: 'Customers', href: '/customers' },
          { label: 'Add Customer' },
        ]}
        actions={
          <Link href="/customers">
            <Button variant="outline" size="sm" className="h-8">
              <ArrowLeft className="mr-1 h-4 w-4" />
              Back
            </Button>
          </Link>
        }
      />

      <div className="flex-1 overflow-auto p-4 md:p-6">
        <Card className="max-w-2xl">
          <CardHeader>
            <CardTitle>Customer Details</CardTitle>
          </CardHeader>
          <CardContent>
            {canManageCustomers ? (
              <NewCustomerForm />
            ) : (
              <Alert>
                <AlertDescription>
                  Admin access is required to create Helm customers.
                </AlertDescription>
              </Alert>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
